import AnnualReportForm from "../../../model/AnnualReportForm";

const IS_PROJECT_COMPLETE = `Have you completed your research project? `;

/**
 * Props for this component
 */
interface IsProjectCompleteQuestionProps {
   form: AnnualReportForm,
   isLocked: boolean,
}

/**
 * Question to confirm if all the researchers are present in the project
 *
 * Used in: {@link ApplicantAnnualReportForm|Applicant annual report}
 *
 * @param form An {@link AnnualReportForm} object with a saved report (Could be empty if it's a new report)
 * @param isLocked A boolean to indicate if the report is locked for editing or not
 */
export default function isProjectCompleteQuestion({form, isLocked}: IsProjectCompleteQuestionProps) {
   // TODO This question will ideally not be saved and instead redirect the researcher to the correct form
   return (
      <div id="isProjectCompleteQ" className="annual-report-question">
         <label id="isProjectCompleteQMainText" className="question-text">{IS_PROJECT_COMPLETE}</label>
         {isLocked ? (
            <span className="boolean-answer">{form.isResearchListCompleted ? 'YES' : 'NO'}</span>
         ) : (
            //Radio Button Area
            <div id="isProjectCompleteQRadioArea" className="yes-or-no-radio">
               <input id="isProjectCompleteQRadioYesInput" className="form-check-input" type="radio"
                      name="isProjectCompleteQRadioSelection"
                      required
                      defaultChecked={(form.annualReportId && form.isResearchListCompleted != null) ? (form.isResearchListCompleted) : false}
               />
               <label id="isProjectCompleteQRadioYesText" className="form-check-label"
                      htmlFor="isProjectCompleteQRadioYesInput">
                  Yes
               </label>
               <input id="isProjectCompleteQRadioNoInput" className="form-check-input" type="radio"
                      name="isProjectCompleteQRadioSelection"
                      required
                      defaultChecked={(form.annualReportId && form.isResearchListCompleted != null) ? (!form.isResearchListCompleted) : false}
               />
               <label id="isProjectCompleteQRadioNoText" className="form-check-label"
                      htmlFor="isProjectCompleteQRadioNoInput">
                  No
               </label>
               <div id="isProjectCompleteQRadioAreaFeedback" className="invalid-feedback">
                  Please select one option.
               </div>
            </div>
         )}
      </div>
   );
}
